import { render, staticRenderFns } from "./consumo-no-autorizado.vue?vue&type=template&id=0ff63574&"
import script from "./consumo-no-autorizado.vue?vue&type=script&lang=ts&"
export * from "./consumo-no-autorizado.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports